'use strict';

let $cache = {
    rxContainer: $('#rxB2C-container'),
    sections: $('.rx-form-section'),
    section1: $('.rx-form-section[data-step="1"]'),
    section2: $('.rx-form-section[data-step="2"]'),
    section3: $('.rx-form-section[data-step="3"]'),
    section4: $('.rx-form-section[data-step="4"]'),
    section5: $('.rx-form-section[data-step="5"]'),
    forms: $('.rx-form-section'),
    pdWidgetWrapper: $(".msrt-wrapper"),
    pdWidget: $('#msrt-container'),
    pdResultInput: $('#dwfrm_rxB2CForm_pupillaryDistance'),
    nav: $('.rx-stepper')
};

const dataLayerFonctions = require('./rxB2CDataLayer');
const NB_STAGES = 5;

/**
 * open a new section and close the previous one
 * @param {string|integer} stepNumber - current step to open
 */
function openSection(stepNumber) {
    $('.rx-form-section:not([data-step="' + stepNumber + '"])').removeClass('active');
    $cache['section' + stepNumber].show().addClass('active');
    $cache.rxContainer.attr('data-current-step', stepNumber);
    handleNavigation(stepNumber);
}

/**
 * Launch Pupillary Distance Widget
 * @param {*} $currentSection - context node element
 */
function launchMsrt($currentSection) {
    $cache.pdWidgetWrapper.show();
    const params = {
        apiKey: $cache.pdWidget.attr('data-api-key'),
        ...(JSON.parse($cache.pdWidget.attr('data-theme-config') || {})),
    };
    const $nextBtn = $('.js-next-btn', $currentSection);
    const $launchPDBtn = $('.js-launch-pd', $currentSection);
    const $resultWrapper = $('.js-pd-result-wrapper', $currentSection);
    const $fittingBoxWrapper = $('.js-fitting-box-wrapper', $currentSection);

    $nextBtn.addClass('disabled');
    $('body').addClass('modal-open');
    $('.js-error-pd-missing', $currentSection).addClass('d-none');

    window.closeMsrt = function () {
        $cache.pdWidgetWrapper.hide();
        $cache.pdWidget.html('');
        $('body').removeClass('modal-open');
        if ($cache.pdResultInput.val()) {
            $resultWrapper.removeClass('d-none');
            $nextBtn.removeClass('disabled');
            $launchPDBtn.addClass('d-none');
            $fittingBoxWrapper.addClass('d-none');
        } else {
            $resultWrapper.addClass('d-none');
            $nextBtn.addClass('disabled');
            $launchPDBtn.removeClass('d-none');
            $fittingBoxWrapper.removeClass('d-none');
        }
        $('html, body').animate({
            scrollTop: 0
        }, 500);
    };

    Msrt.createWidget("msrt-container", {
        ...params,
        onGetResultPd: (result) => {
            let pdValue = result.pd;
            if (result.left && result.right) {
                pdValue += '|' + result.left + '|' + result.right;
            }
            $('body').trigger('rxForm:PDResultReceived', [pdValue]);
        },
        onTooManyErrors: () => { console.log('Errors PD widget'); closeMsrt(); },
        onClose: () => {
            window.closeMsrt();
        }
    });
};

/**
 * Init events of section 1
 * @returns {Promise} promise
 */
function initSection1() {
    return new Promise((resolve, reject) => {
        const SECTION_STEP = 1;
        openSection(SECTION_STEP);
        let $currentSection = $cache.section1;
        let $ajaxResultWrapper = $('.js-ajax-result', $currentSection);
        function initAjaxResponse() {
            $('.js-choose-lens-wrapper.selected .js-choose-lens', $currentSection).prop('disabled', true);
        }

        $.ajax({
            method: 'get',
            url: $ajaxResultWrapper.attr('data-url'),
            success: function (data) {
                $ajaxResultWrapper.html(data);
                initAjaxResponse();
            }
        });

        $currentSection.off('click', '.js-choose-lens').on('click', '.js-choose-lens', function (e) {
            e.preventDefault();
            let $wrapper = $(this).closest('.js-choose-lens-wrapper');
            let pid = $wrapper.attr('data-lens-pid');
            let $input = $('input[name="dwfrm_rxB2CForm_lensID"]', $currentSection);
            $input.val(pid);

            dataLayerFonctions.pushLensChange();

            $.ajax({
                url: $currentSection.attr('action'),
                method: $currentSection.attr('method'),
                data: $currentSection.serialize(),
                success: function (data) {
                    $ajaxResultWrapper.html(data);
                    initAjaxResponse();
                    $('#lenses-options', $currentSection).addClass('show');
                }
            });
        });
        return resolve();
    });
}

/**
 * Init events of section 2
 * @returns {Promise} promise
 */
function initSection2() {
    return new Promise((resolve, reject) => {
        const SECTION_STEP = 2;
        openSection(SECTION_STEP);
        let $currentSection = $cache.section2;
        let $lensSection = $cache.section1;
        let $ajaxResultWrapper = $('.js-ajax-result', $currentSection);

        function initAjaxResponse() {
            $.ajax({
                method: 'get',
                url: $ajaxResultWrapper.attr('data-url'),
                success: function (data) {
                    $ajaxResultWrapper.html(data);
                    $ajaxResultWrapper.find('[data-toggle="tooltip"]').tooltip();
                }
            })
        }
        initAjaxResponse();

        $currentSection.off('click', '.js-choose-lens').on('click', '.js-choose-lens', function (e) {
            e.preventDefault();
            let $this = $(this);
            let pid = $this.attr('data-pid');
            let $input = $('input[name="dwfrm_rxB2CForm_lensID"]', $lensSection);
            $input.val(pid);

            $.ajax({
                url: $lensSection.attr('action'),
                method: $lensSection.attr('method'),
                data: $lensSection.serialize(),
                success: function () {
                    initAjaxResponse();
                }
            });
        });
        return resolve();
    });
}

/**
 * Init events of section 3
 * @returns {Promise} promise
 */
function initSection3() {
    return new Promise((resolve, reject) => {
        const SECTION_STEP = 3;
        openSection(SECTION_STEP);
        let $currentSection = $cache.section3;
        let $ajaxResultWrapper = $('.js-ajax-result', $currentSection);

        function initAjaxResponse() {
            $.ajax({
                method: 'get',
                url: $ajaxResultWrapper.attr('data-url'),
                success: function (data) {
                    $ajaxResultWrapper.html(data);
                }
            })
        }
        initAjaxResponse();
        return resolve();
    });
}

/**
 * Init events of section 4
 * @returns {Promise} promise
 */
function initSection4() {
    return new Promise((resolve, reject) => {
        const SECTION_STEP = 4;
        let $currentSection = $cache.section4;
        let $ajaxResultWrapper = $('.js-ajax-result', $currentSection);

        function initAjaxResponse() {
            $.ajax({
                method: 'get',
                url: $ajaxResultWrapper.attr('data-url'),
                success: function (data) {
                    $ajaxResultWrapper.html(data);
                    return resolve();
                }
            })
        }
        initAjaxResponse();

        const $nextBtn = $('.js-next-btn', $currentSection);
        const $launchPDBtn = $('.js-launch-pd');
        const $setSubStepBtn = $('.js-pd-set-sub-step', $currentSection);
        const $pdManualCheckbox = $('.js-pd-input-double-checkbox', $currentSection);

        openSection(SECTION_STEP);
        if ($cache.pdResultInput.val()) {
            $nextBtn.removeClass('disabled');
        }
        $launchPDBtn.off('click').on('click', function () {
            launchMsrt($currentSection);
            dataLayerFonctions.pushPDMeasureWidget();
        });
        $('.msrt-overlay', $currentSection).off('click').on('click', function () {
            window.closeMsrt();
        });
        $nextBtn.on('click', function () {
            const $errorBox = $('.js-error-pd-validation', $currentSection);
            $errorBox.addClass('d-none').text('');
            $('.js-error-pd-missing', $currentSection).addClass('d-none');
        
            if ($(this).hasClass('disabled')) {
                $('.js-error-pd-missing', $currentSection).removeClass('d-none');
                return false;
            }
        
            const isDouble = $pdManualCheckbox.is(':checked');
            const pdMin = window.app.preferences.pdMinValue;
            const pdMax = window.app.preferences.pdMaxValue;
            const eyeMin = pdMin / 2;
            const eyeMax = pdMax / 2;
        
            let errorMessage = '';
        
            if (isDouble) {
                const left = parseFloat($('[name="pd-value-left"]', $currentSection).val());
                const right = parseFloat($('[name="pd-value-right"]', $currentSection).val());
        
                if (isNaN(left) || isNaN(right)) return false;
        
                const total = left + right;
                const diff = Math.abs(left - right);
        
                const leftInvalid = left < eyeMin || left > eyeMax;
                const rightInvalid = right < eyeMin || right > eyeMax;
        
                if (leftInvalid && !rightInvalid) {
                    errorMessage = $errorBox.data('msg-left').replace('{0}', eyeMin).replace('{1}', eyeMax);
                } else if (rightInvalid && !leftInvalid) {
                    errorMessage = $errorBox.data('msg-right').replace('{0}', eyeMin).replace('{1}', eyeMax);
                } else if (leftInvalid && rightInvalid) {
                    errorMessage = $errorBox.data('msg-both').replace('{0}', eyeMin).replace('{1}', eyeMax);
                } else if (total < pdMin || total > pdMax) {
                    errorMessage = $errorBox.data('msg-single').replace('{0}', pdMin).replace('{1}', pdMax);
                } else if (diff > 5) {
                    errorMessage = $errorBox.data('msg-diff');
                }
        
            } else {
                const pd = parseFloat($('[name="pd-value"]', $currentSection).val());
                if (!isNaN(pd) && (pd < pdMin || pd > pdMax)) {
                    errorMessage = $errorBox.data('msg-single').replace('{0}', pdMin).replace('{1}', pdMax);
                }
            }
        
            if (errorMessage) {
                $errorBox.text(errorMessage).removeClass('d-none');
                return false;
            }
        });
        
        $setSubStepBtn.on('click', function () {
            const pdMode = $(this).attr('data-pd-mode');

            window.savePDValue(null);
            dataLayerFonctions.pushPDMeasureMode(pdMode);

            $setSubStepBtn.removeClass('active');
            $(this).addClass('active');

            $('.js-pd-pane-sub-section', $currentSection).addClass('d-none');
            $(`.js-pd-pane-sub-section[data-pd-mode="${pdMode}"]`, $currentSection).removeClass('d-none');
            $('.js-pd-manual-value-container', $currentSection).find('.js-pd-manual-input').val('');

            console.log(pdMode,  $('.js-sub-step-measure-wrapper', $currentSection))
            if (pdMode === 'manual') {
                $('.js-sub-step-measure-wrapper', $currentSection).removeClass('d-none');
            } else {
                $('.js-sub-step-measure-wrapper', $currentSection).addClass('d-none');
            }
        });

        $pdManualCheckbox.on('change', function () {
            $('.js-pd-manual-value-container', $currentSection).addClass('d-none').find('.js-pd-manual-input').val('');
            window.savePDValue(null);
            if ($(this).is(':checked')) {
                $('.js-pd-manual-value-container[data-type="double"]', $currentSection).removeClass('d-none');
            } else {
                $('.js-pd-manual-value-container[data-type="single"]', $currentSection).removeClass('d-none');
            }
        });

        function savePDValue(pdValue) {
            const $launchPDBtn = $('.js-launch-pd');
            const $resultWrapper = $('.js-pd-result-wrapper', $currentSection);
            var $jsCustomerPDContainer = $('.js-customer-pd', $currentSection);
            const $fittingBoxWrapper = $('.js-fitting-box-wrapper', $currentSection);
            const mesureUnit = $resultWrapper.attr('data-mesure-unit');
            const labelRight = $resultWrapper.attr('data-label-right');
            const labelLeft = $resultWrapper.attr('data-label-left');
            let formattedHtml = '';

            // Split the pdValue into its components
            if (pdValue) {
                const values = pdValue.toString().split('|');

                // Check the number of values and construct the formatted string accordingly
                if (values.length === 3) {
                    formattedHtml = `${labelRight}: ${values[2]} ${mesureUnit}, ${labelLeft}: ${values[1]} ${mesureUnit}`;
                } else if (values.length === 2) {
                    formattedHtml = `${labelRight}: ${values[1]} ${mesureUnit}, ${labelLeft}: ${values[0]} ${mesureUnit}`;
                } else if (values.length === 1) {
                    formattedHtml = `${values[0]} ${mesureUnit}`;
                }
            }
            $jsCustomerPDContainer.html(formattedHtml);

            $cache.pdResultInput.val(pdValue);

            if (pdValue) {
                $nextBtn.removeClass('disabled btn-featured');
                $nextBtn.addClass('btn-primary');
    
                $launchPDBtn.addClass('d-none');
                $resultWrapper.removeClass('d-none');
                $('html, body').animate({
                    scrollTop: 0
                }, 500);
            } else {
                $nextBtn.addClass('disabled btn-featured');
                $nextBtn.removeClass('btn-primary');
                $launchPDBtn.removeClass('d-none');
                $fittingBoxWrapper.removeClass('d-none');
                $resultWrapper.addClass('d-none');
            }
        }
        window.savePDValue = savePDValue;

        $('.js-pd-manual-input', $currentSection).on('change, keyup', function () {
            let name = $(this).attr('name');
            let value = parseFloat($(this).val());
            let finalValue = value;

            if (isNaN(value)) {
                finalValue = '';
            } else {
                if (name === 'pd-value') {
                    finalValue = value;
                } else {
                    let right = $('.js-pd-manual-input[name="pd-value-right"]', $currentSection).val();
                    let left = $('.js-pd-manual-input[name="pd-value-left"]', $currentSection).val();
                    finalValue = left && right ? left + '|' + right : '';
                }
            }
            window.savePDValue(finalValue ? [finalValue] : null);
        });

        function PDResultReceived(e, pdValue) {
            window.savePDValue(pdValue);
            window.closeMsrt();
        };
        $('body').on('rxForm:PDResultReceived', PDResultReceived);
    });
}

/**
 * Init events of section 5
 * @returns {Promise} promise
 */
function initSection5() {
    return new Promise((resolve, reject) => {
        const SECTION_STEP = 5;
        openSection(SECTION_STEP);
        let $currentSection = $cache.section5;
        let $ajaxResultWrapper = $('.js-ajax-result', $currentSection);

        $.ajax({
            method: 'get',
            url: $ajaxResultWrapper.attr('data-url'),
            success: function (data) {
                $ajaxResultWrapper.html(data);
                return resolve();
            }
        });
    });
}

/**
 * verify form entries of section 1
 * @returns {Promise} promise
 */
function verifySection1() {
    return new Promise((resolve, reject) => {
        let $form = $cache.section1;
        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: $form.serialize(),
            success: function () {
                return resolve();
            },
            error: function () {
                return reject();
            }
        });
    });
}

/**
 * verify form entries of section 2
 * @returns {Promise} promise
 */
function verifySection2() {
    return new Promise((resolve, reject) => {
        let $form = $cache.section2;
        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: $form.serialize(),
            success: function (data) {
                if (data.success) {
                    return resolve();
                }
                return reject();
            },
            error: function () {
                return reject();
            }
        });
    });
}

/**
 * verify form entries of section 3
 * @returns {Promise} promise
 */
function verifySection3() {
    return new Promise((resolve, reject) => {
        let $form = $cache.section3;
        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: new FormData($form[0]),
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            dataType: 'json',
            timeout: 60000,
            cache: false,
            success: function (data) {
                if (data.success) {
                    return resolve();
                }
                $('input[type="file"]', $form).trigger('invalid');
                return reject();
            },
            error: function () {
                return reject();
            }
        });
    });
}

/**
 * verify form entries of section 4
 * @returns {Promise} promise
 */
function verifySection4() {
    return new Promise((resolve, reject) => {
        if ($('.js-error-pd-validation:visible').length > 0) {
            return reject('PD validation failed');
        }
        let $form = $cache.section4;
        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: $form.serialize(),
            success: function (data) {
                if (data.success) return resolve();
                return reject();
            },
            error: function () {
                return reject();
            }
        });
    });
}

/**
 * verify form entries of section 5
 * @returns {Promise} promise
 */
function verifySection5() {
    return new Promise((resolve, reject) => {
        let $form = $cache.section5;

        if ($('#rxB2CAddToCartModal input[name="customerConfirmSubmit"]').val() !== 'true') {
            $('body').trigger('rxb2c:openconfirmationmodal', {
                actionTarget: $('.js-next-btn', $form).first(),
                productToAddIsRX: true
            });
            return reject();
        }

        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: $form.serialize(),
            success: function (data) {
                if (data.success) {
                    if (data.redirectUrl) {
                        location.href = data.redirectUrl;
                    }
                    return resolve();
                } else {
                    if (data.errorMessage) {
                        $('.js-error-mg', $form).html(data.errorMessage).removeClass('d-none');
                        $('html, body').animate({
                            scrollTop: $('.js-error-mg', $form).offset().top
                        }, 500);
                    }
                    return reject();
                }
            },
            error: function () {
                return reject();
            }
        });
    });
}

let functionNamesMap = {
    verifySection1: verifySection1,
    verifySection2: verifySection2,
    verifySection3: verifySection3,
    verifySection4: verifySection4,
    verifySection5: verifySection5,
    initSection1: initSection1,
    initSection2: initSection2,
    initSection3: initSection3,
    initSection4: initSection4,
    initSection5: initSection5
};

/**
 * Call step function for a given section and a given action
 * @param {string} action - verify|init
 * @param {string} step - given section number
 * @returns {Promise} response
 */
async function callSectionFunction(action, step) {
    let result = await functionNamesMap[action + 'Section' + step]();
    let $setMinHeight = $('.rx-form-section.active .js-set-min-height', $cache.rxContainer);
    let $minHeightRef = $('.rx-form-section.active .js-min-height-ref', $cache.rxContainer);

    if ($setMinHeight.length > 0 && $minHeightRef.length > 0) {
        $setMinHeight.css('min-height', $minHeightRef.outerHeight() + 'px');
    }

    return result;
}

/**
 * Clear error message
 */
function clearErrorMessage() {
    $('.rx-error-message .alert-danger').addClass('d-none');
    $('.rx-error-message:visible .alert-danger .error-message-text').html('');
}
/**
 * Show error message
 * @param {any} e - error
 */
function showErrorMessage(e) {
    $('.rx-error-message:visible .alert-danger').removeClass('d-none');
    $('.rx-error-message:visible .alert-danger .error-message-text').html(e);
}

/**
 * Update a step when the current step has changed
 * @param {number} currentStep - current  step
 */
async function updateStep(currentStep) {
    $cache.rxContainer.attr('data-current-step', currentStep);
    await callSectionFunction('init', currentStep);
    setTimeout(function () {
        $('.rx-form-section:not(.active)').hide();
    }, 400);
}

/**
 * Handle tabs activation
 * @param {number} currentStep - current  step
 */
function handleNavigation(currentStep) {
    $cache.nav.find('.step').removeClass('active disabled completed');
    $cache.nav.find('.step .rx-nav-link').removeAttr('disabled');
    $cache.nav.find('.rx-stepper-' + currentStep).addClass('active');

    for (let i = 1; i < currentStep; i += 1) {
        $cache.nav.find('.rx-stepper-' + i).addClass('completed');
    }

    for (let i = currentStep + 1; i <= NB_STAGES; i += 1) {
        $cache.nav.find('.rx-stepper-' + i).addClass('disabled');
        $cache.nav.find('.rx-stepper-' + i + ' .rx-nav-link').attr('disabled', 'disabled');
    }
}

function initFileInput() {
    const $nextButton = $('.js-next-btn[data-next-step="4"]');

    $(document).on('change', '#dwfrm_rxB2CForm_file', function () {
        const hasFile = this.files && this.files.length > 0;

        $nextButton
            .toggleClass('btn-primary', hasFile)
            .toggleClass('btn-featured', !hasFile)
            .toggleClass('disabled', !hasFile);
    });
}

module.exports = {
    init: async function init() {
        window.dataLayer = window.dataLayer || [];

        var currentStep = $cache.rxContainer.attr('data-current-step');
        $('.rx-form-section:not(.active)').hide();
        await callSectionFunction('init', currentStep);

        /** START: navigation listeners and history */
        $cache.sections.on('click', '.js-next-btn',  async function handleClick() {
            let $this = $(this);
            let $container = $this.closest('.rx-form-section');
            let currentSection = $container.attr('data-step');
            let nextSection = $this.attr('data-next-step');
            let isJumpStep = $this.attr('data-is-jump-step') === 'true';

            dataLayerFonctions.pushClickNext(currentSection, $container);

            try {
                if (!isJumpStep) {
                    await callSectionFunction('verify', currentSection);
                }
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'instant'
                });
                clearErrorMessage();
                currentStep = nextSection;
                // Add Current Step in param

                if (nextSection !== 'checkout') {
                    history.pushState(
                        nextSection,
                        document.title,
                        location.pathname
                        + '?step='
                        + nextSection
                    );
                }
                await updateStep(nextSection);
            } catch (e) {
                console.log('ERROR ON VERIFY SECTION', e);
                clearErrorMessage();
                if (e && e.length > 0) {
                    showErrorMessage(e);
                }
            }
        });

        $cache.sections.on('click', '.js-prev-btn',  async function handleClick(e) {
            e.preventDefault();
            const currentSection = $(this).closest('.rx-form-section').attr('data-step');
            const requestedStep = $(this).attr('data-prev-step');

            dataLayerFonctions.pushClickPrev(currentSection);

            await updateStep(requestedStep);
            history.pushState(
                requestedStep,
                document.title,
                location.pathname
                + '?step='
                + requestedStep
            );
        });
        
        $('.rx-stepper .step').on('click', async function(e) {
            e.preventDefault();
            if(!$(this).hasClass('disabled') && $(this).hasClass('completed')) {
                const currentSection = $cache.rxContainer.attr('data-current-step');
                const requestedStep = $(this).find('.rx-nav-link').attr('data-step');

                dataLayerFonctions.pushClickStepper(currentSection, requestedStep);

                await updateStep(requestedStep);
                history.pushState(
                    requestedStep,
                    document.title,
                    location.pathname
                    + '?step='
                    + requestedStep
                );
            }
        });
        
        initFileInput()

        // Handle Previous and next button
        $(window).on('popstate', async function () {
            var url = window.location.href;
            var match = url.match(/[\?&]step=([^&#]*)/);
            if (match) {
                currentStep = match[1];
            } else {
                currentStep = 0;
            }
            await updateStep(currentStep);
        });

        /** END: navigation listeners and history */
        function getQueryParam(param) {
            return new URLSearchParams(window.location.search).get(param);
        }
        function updateUrlParameter(param, value) {
            var currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set(param, value);
            window.history.replaceState({}, '', currentUrl);
        }

        var currentStep = $cache.rxContainer.attr('data-current-step');
        var urlStep = getQueryParam('step');
        if (currentStep !== urlStep) {
            updateUrlParameter('step', currentStep);
        }
    }
};

